import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'logpn-form-action-buttons',
  templateUrl: './form-action-buttons.component.html',
  styleUrl: './form-action-buttons.component.scss',
  imports: [TranslocoPipe],
})
export class FormActionButtonsComponent {
  @Input() saveLabel = 'forms.save';
  @Input() cancelLabel = 'forms.cancel';
  @Output() cancelEvent = new EventEmitter<void>();

  onCancel() {
    this.cancelEvent.emit();
  }
}
